// CookieErrorDisplay — US-134 (red banner shown on `error`).

import { useT } from '@barel/i18n';
import { Banner } from '@barel/ui';

export interface CookieErrorDisplayProps {
  reason: string;
}

export function CookieErrorDisplay({ reason }: CookieErrorDisplayProps) {
  const t = useT('campaigns');
  return (
    <Banner tone="error" variant="soft" title={reason} data-testid="cookie-error-banner">
      {t('detail.errorBanner')}
    </Banner>
  );
}
